import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@material-ui/core';
import { Box, Stack, Drawer, Typography } from '@material-ui/core';
// hooks
import useAuth from '../../hooks/useAuth';
import useLocales from '../../hooks/useLocales';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import useAdminNavConfig from './adminNavConfig';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[500_12],
}));

// ----------------------------------------------------------------------

AdminSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function AdminSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { translate } = useLocales();
  const navConfig = useAdminNavConfig(translate);

  useEffect(() => {
    if (isOpenSidebar) onCloseSidebar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar sx={{ height: '100%', '& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column' } }}>
      <Stack spacing={3} sx={{ px: 2.5, pt: 3, pb: 2 }}>
        <Box component={RouterLink} to="/admin/users" sx={{ display: 'inline-flex' }}>
          <Logo />
        </Box>

        <AccountStyle>
          <Box>
            <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
              {user?.displayName || user?.email}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {translate('admin.role')}
            </Typography>
          </Box>
        </AccountStyle>
      </Stack>

      <NavSection navConfig={navConfig} />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: DRAWER_WIDTH } }}>
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{ sx: { width: DRAWER_WIDTH, bgcolor: 'background.default' } }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
